import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Card from '@mui/joy/Card';
import FoldableInput from '../../../inputs/FoldableInput';
import Typography from '@mui/joy/Typography';
import Divider from '@mui/joy/Divider';
import Checkbox from '@mui/joy/Checkbox';
import Sheet from '@mui/joy/Sheet';
import SearchDropdown from '../../../inputs/SearchDropdown';
import ImageCapture from '../../../inputs/ImageCapture'; // Import the new component
import axios from 'axios';
import domain from "../../../../util/domain";
import CapturedLocation from '../../../inputs/CapturedLocation';
import UserContext from "../../../../context/UserContext";
import AddIcon from '@mui/icons-material/Add';

export default function AddHOD({ details }) {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { visit } = location.state || {};
    //console.log("HODEdit: hodDetails: ", visit);
    const visitDetails_id = visit?.visitDetails_id ?? visit?.id ?? null;
    const college_id = visit?.college_id ?? visit?.id ?? null;
    const createdBy = user.id;
    const [hodname, setHodname] = useState("");
    const [hod_email, setHod_email] = useState("");
    const [hod_mobile, setHod_mobile] = useState("");
    const [isStudentDataShared, setIsStudentDataShared] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [branch, setBranch] = useState("");
    const [capturedPhoto, setCapturedPhoto] = useState(null);
    const [capturedNoticePhoto, setCapturedNoticePhoto] = useState(null);
    const [geoLocation, setGeoLocation] = useState({ lat: 0, lon: 0 });

    const handleNoticeCapture = (photo) => {
        setCapturedNoticePhoto(photo);
    }
    const handleCapture = (photo) => {
        setCapturedPhoto(photo);
    };

    const updateLocation = (location) => {
        //console.log("location: ", location);
        setGeoLocation(location);
    };

    const batchCanged = (selectedOption) => {
        //console.log("Selected Option: ", selectedOption);
        setBranch(selectedOption.branch);
    }
    const cancelAction = (e) => {
        e.preventDefault();
        navigate(-1);
    }
    const updateHOD = (e) => {
        e.preventDefault();
        axios.post(`${domain}/hods/`, {
            hodname,
            hod_email,
            hod_mobile,
            isStudentDataShared,
            remarks,
            visitDetails_id,
            college_id,
            createdBy,
            branch,
            longitude: geoLocation.lon,
            latitude: geoLocation.lat,
            newPhoto: capturedPhoto,
            newNoticePhoto: capturedNoticePhoto,
        })
            .then((response) => {
                //console.log("HOD ADD: response: ", response.data);
            })
            .catch((error) => {
                console.error("HOD ADD error: ", error);
            });
        navigate(-1);
    }

    return (
        <form>
            <Card>
                <Typography level="title-lg" startDecorator={<AddIcon />}>
                    {`Add HOD Details`}
                </Typography>
                <Divider inset="none" />

                <Sheet sx={{ height: '44px', paddingBottom: '10px' }}>
                    <SearchDropdown defaultOption={{ branch }} onBatchChange={batchCanged} />
                </Sheet>
                <FoldableInput inputType='text' labelText={`HOD Name`} placeHolderText={`HOD Name`} value={hodname} onChange={(e) => setHodname(e.target.value)} />
                <FoldableInput inputType='phone' labelText={`HOD Mobile`} placeHolderText={`HOD Mobile`} value={hod_mobile} onChange={(e) => setHod_mobile(e.target.value)} />
                <FoldableInput inputType='email' labelText={`HOD E-Mail`} placeHolderText={`HOD E-Mail`} value={hod_email} onChange={(e) => setHod_email(e.target.value)} />
                <FoldableInput inputType='textarea' labelText={`HOD Remarks`} placeHolderText={`HOD Remarks`} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
                <Sheet variant="outlined" sx={{ height: '44px' }}>
                    <Checkbox overlay label="Is Student Data Shared?"
                        sx={{ alignContent: 'center', paddingLeft: '10px', marginTop: '13px' }}
                        checked={(isStudentDataShared === 0) ? false : true}
                        onChange={(e) => {
                            setIsStudentDataShared((e.target.checked) ? 1 : 0);
                        }}
                    />
                </Sheet>
                <CapturedLocation onUpdateLocation={updateLocation} />
                {/* Image Capture Component */}
                <ImageCapture title={`HOD Photo`} onCapture={handleCapture} />

                <ImageCapture title={`HOD Notice Board`} onCapture={handleNoticeCapture} />

                <button type="button" onClick={cancelAction}>Cancel</button>
                <button type="submit" onClick={updateHOD}>Save</button>
            </Card>
        </form>
    );
}